<template>
  <div class="container">
    <!-- 666 只能来单层div，不能多层 -->
    <div class="title">
      <div class="title-text">
        <img src="./imgs/navigation_icon_goods.png" class="title-logo" />
        <span>属性管理</span>
      </div>
      <el-button type="primary" size="small" class="add-button" @click="openAddDialog()">添加</el-button>
    </div>

    <!-- 主要列表，展示多行 -->
    <el-table :data="tableData" border style="width: 100%">
      <!--      <el-table-column type="index" width="50" :index="indexMethod"></el-table-column>-->
      <el-table-column prop="id" label="属性id"></el-table-column>
      <el-table-column prop="propertyName" label="属性名称"></el-table-column>
      <el-table-column prop="propertyCode" label="属性编码"></el-table-column>
      <el-table-column prop="propertyValues" label="属性值"></el-table-column>

      <el-table-column prop="opt" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="openEditDialog(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagation-wrapper">
      <span class="pagation-text">共{{pageParam.totalPage}}页/共{{pageParam.totalCount}}条</span>
      <el-pagination layout="prev, pager, next"
                     :total="pageParam.totalCount"
                     :page-size="pageParam.pageSize"
                     :current-page.sync="pageParam.currentPage"
                     @current-change="reloadPropertyList"></el-pagination>
    </div>
    <!-- 新增、修改使用表单 -->
    <div>
      <el-dialog title="属性管理" :visible.sync="isAddDialogShow" :before-close="closeDialogAndResetData">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="属性id" v-if="isShowIdInput">
            <el-input v-model="form.id" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="属性名称" prop="propertyName">
            <el-input v-model="form.propertyName" autocomplete="off" maxlength="60"
                      show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="属性编码" prop="propertyCode">
            <el-input v-model="form.propertyCode" autocomplete="off" maxlength="30"
                      show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="属性值" :required="true">
            <br />
            <el-tag
                    :key="tag"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
            >{{tag}}
            </el-tag>
            <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
            ></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialogAndResetData">取 消</el-button>
          <el-button type="primary" @click="handleDialogSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  let commonParams = {
    // platformId: 1,
    // merchantId: 0,
    // operator: "admin"
  };
  export default {
    mounted() {
      this.reloadPropertyList();
    },
    data() {
      return {
        tableData: [
          // {
          //   id: "1",
          //   propertyName: "demo",
          //   propertyCode: "demo",
          //   propertyValues: "demo"
          // },
          // {
          //   id: "1",
          //   propertyName: "demo",
          //   propertyCode: "demo",
          //   propertyValues: "demo1|demo2|demo3"
          // }
        ],
        isAddDialogShow: false,
        dialogOperation: "insert",
        isShowIdInput: false,
        dynamicTags: [],
        inputVisible: false,
        inputValue: "",
        form: {
          propertyName: "",
          propertyCode: "",
          propertyValues: ""
        },
        pageParam: {
          totalCount: 0,
          totalPage: 1,
          currentPage: 1,
          pageSize: 10,
        },
        rules: {
          "propertyName": [{required: true, message: '属性名称不能为空'}],
          "propertyCode": [{required: true, message: '属性编码不能为空'}],
        }
      };
    },
    methods: {
      indexMethod(index) {
        let realIndex = (this.pageParam.currentPage - 1) * this.pageParam.pageSize + index + 1;
        return realIndex;
      },
      /**
       * 重新加载属性列表
       */
      reloadPropertyList() {
        let params = Object.assign(this.pageParam, commonParams);
        console.log("params", params);
        this.$api
          .attributeList(params)
          .then(res => {
            // 接口成功做的操作
            if (!res || res["code"] !== 0) {
              this.$message({
                type: "error",
                message: res["msg"]
              });
              return;
            }
            this.tableData = res.data.page.data.propertyList;
            this.pageParam = {
              totalCount: res.data.page.totalCount,
              totalPage: res.data.page.totalPage,
              currentPage: res.data.page.currentPage,
              pageSize: res.data.page.pageSize,
            }
          })
          .catch(e => {
            // 接口失败做的操作
            console.log(e);
            this.$message({
              type: "error",
              message: "系统异常请稍候再试"
            });
          });
      },
      /**
       * 新增标签方法
       */
      openAddDialog() {
        this.form = {};
        if (this.$refs["form"]) {
          this.$refs["form"].resetFields();
        }
        this.dynamicTags = [];
        this.isShowIdInput = false;
        this.isAddDialogShow = true;
        this.dialogOperation = "insert";
      },
      /**
       * 编辑标签
       */
      openEditDialog(id, row) {
        this.form = row;
        this.dynamicTags = row.propertyValues.split("|");
        this.isShowIdInput = true;
        this.isAddDialogShow = true;
        this.dialogOperation = "update";
      },
      /**
       * 删除标签
       */
      handleDelete(id, row) {
        console.log("delete", id, row);
        let data = Object.assign({id: row.id}, commonParams);
        this.$confirm("确认删除？")
          .then(() => {
            this.doDeleteRecord(data);
          });
      },
      doDeleteRecord(data) {
        this.$api.deleteAttribute(data).then(
          res => {
            if (!res || res["code"] !== 0) {
              this.$message({
                type: "error",
                message: res["msg"]
              });
            } else {
              this.$notify({
                title: "提示",
                message: "删除成功",
                type: "success",
                duration: 1500
              });
              // this.closeDialogAndResetData();
              this.reloadPropertyList();
            }
          }).catch(e => {
          console.log(e);
          this.$message({
            type: "error",
            message: "系统异常请稍候再试"
          });
        })

      },
      /**
       * 表单提交
       */
      handleDialogSubmit(data) {
        data = Object.assign(this.form, commonParams);
        data.propertyValues = this.dynamicTags.join("|");
        let isFormValidate = false;
        this.$refs["form"].validate((valid) => {
          if (valid) {
            isFormValidate = true;
          } else {
            return false;
          }
        });
        if (!isFormValidate) {
          return;
        }
        if (this.dialogOperation === "insert") {
          this.doInsertRecord(data);
        } else {
          this.doUpdateRecord(data);
        }
      },
      doInsertRecord(data) {
        console.log(data);
        this.$api
          .createAttribute(data)
          .then(res => {
            console.log(res);
            if (!res || res["code"] !== 0) {
              this.$message({
                type: "error",
                message: res["msg"]
              });
              return;
            } else {
              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 1500
              });
              this.closeDialogAndResetData();
              this.reloadPropertyList();
            }

          })
          .catch(e => {
            // 接口失败做的操作
            console.log(e);
            this.$message({
              type: "error",
              message: "系统异常请稍候再试"
            });
          });
      },

      doUpdateRecord(data) {
        console.log(data);
        this.$api.updateAttribute(data).then(res => {
          if (!res || res["code"] !== 0) {
            this.$message({
              type: "error",
              message: res["msg"]
            });
          } else {
            this.$notify({
              title: "提示",
              message: "更新成功",
              type: "success",
              duration: 1500
            });
            this.closeDialogAndResetData();
            this.reloadPropertyList();
          }
        }).catch(e => {
          console.log(e)
        })
      },
      closeDialogAndResetData() {
        this.isAddDialogShow = false;
        this.form = {};
        this.dynamicTags = [];
      },
      // ------------------------- tag 代码 开始---------------------
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = "";
      }
      // ------------------------- tag 代码 结束---------------------
    }
  };
</script>
<style lang="less" scoped>
  .container {
    /*height: 2000px;*/

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      border: solid 1px #ebeef5;
      color: #303133;
      font-size: 20px;
      padding: 20px 15px;
      border-radius: 4px;
      margin: 0 0 20px 0;

      .title-text {
        display: flex;
        align-items: center;

        .title-logo {
          width: 20px;
          margin-right: 12px;
        }
      }

      .add-button {
        float: right;
      }
    }
  }

  .pagation-wrapper {
    background: #ffffff;
    display: flex;
    align-items: center;
    float: right;
    margin: 20px;

    .pagation-text {
      margin-right: 10px;
      font-weight: 400;
      color: #606266;
    }
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
